export default __webpack_public_path__ + "static/media/Shadow's Gloves of the Final Way.2a9c7d1b.jpg";